import { render, staticRenderFns } from "./PowerBI.vue?vue&type=template&id=5d407830&"
import script from "./PowerBI.vue?vue&type=script&lang=js&"
export * from "./PowerBI.vue?vue&type=script&lang=js&"
import style0 from "./PowerBI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports